import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { UTLabel } from '@widergy/energy-ui';

import { message } from '../../../../../../../utils/stringUtils';
import IconButton from '../../components/IconButton';

import stylesCSS from './styles.module.scss';
import styles from './styles';

const CenteredIcons = ({ buttons }) => (
  <div style={styles.container}>
    <div style={styles.title}>
      <UTLabel large extrabold>
        {message('Assessor:title')}
      </UTLabel>
    </div>
    <div className={stylesCSS.buttonsContainer}>
      <div className={stylesCSS.buttonsFirstRow}>
        {buttons.map(
          (button, index) => index < 3 && <IconButton {...button} key={button.image} index={index} />
        )}
      </div>
      <div className={stylesCSS.buttonsSecondRow}>
        {buttons.map(
          (button, index) => index >= 3 && <IconButton {...button} key={button.image} index={index} />
        )}
      </div>
    </div>
  </div>
);

CenteredIcons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
      imageHovered: PropTypes.string.isRequired
    }).isRequired
  ).isRequired
};

export default Radium(CenteredIcons);
